var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
var RequestStandardCardComponent = /** @class */ (function () {
    function RequestStandardCardComponent() {
        this.card = Input('card');
        this.requestButtonText = 'REQUEST';
        this.collapseTargetId = '';
        this.collapseTargetSelector = '';
    }
    RequestStandardCardComponent.prototype.ngOnInit = function () {
        this.collapseTargetId = this.card.id + "-collapse";
        this.collapseTargetSelector = "#" + this.collapseTargetId;
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], RequestStandardCardComponent.prototype, "card", void 0);
    RequestStandardCardComponent = __decorate([
        Component({
            selector: 'app-request-standard-card',
            template: require('./request-standard-card.component.html'),
            styles: [require('./request-standard-card.component.scss')]
        }),
        __metadata("design:paramtypes", [])
    ], RequestStandardCardComponent);
    return RequestStandardCardComponent;
}());
export { RequestStandardCardComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC1zdGFuZGFyZC1jYXJkLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJlcXVlc3Qtc3RhbmRhcmQtY2FyZC5jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQVUsTUFBTSxlQUFlLENBQUM7QUFTekQ7SUFNSTtRQUNJLElBQUksQ0FBQyxJQUFJLEdBQUcsS0FBSyxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQzFCLElBQUksQ0FBQyxpQkFBaUIsR0FBRyxTQUFTLENBQUM7UUFDbkMsSUFBSSxDQUFDLGdCQUFnQixHQUFHLEVBQUUsQ0FBQztRQUMzQixJQUFJLENBQUMsc0JBQXNCLEdBQUcsRUFBRSxDQUFDO0lBQ3JDLENBQUM7SUFDTSwrQ0FBUSxHQUFmO1FBQ0ksSUFBSSxDQUFDLGdCQUFnQixHQUFNLElBQUksQ0FBQyxJQUFJLENBQUMsRUFBRSxjQUFXLENBQUM7UUFDbkQsSUFBSSxDQUFDLHNCQUFzQixHQUFHLE1BQUksSUFBSSxDQUFDLGdCQUFrQixDQUFDO0lBQzlELENBQUM7SUFiUTtRQUFSLEtBQUssRUFBRTs7OERBQW1CO0lBRmxCLDRCQUE0QjtRQUx4QyxTQUFTLENBQUM7WUFDUCxRQUFRLEVBQUUsMkJBQTJCO1lBQ3JDLFFBQVEsRUFBRSxPQUFPLENBQUMsd0NBQXdDLENBQUM7WUFDM0QsTUFBTSxFQUFFLENBQUMsT0FBTyxDQUFDLHdDQUF3QyxDQUFDLENBQUM7U0FDOUQsQ0FBQzs7T0FDVyw0QkFBNEIsQ0FnQnhDO0lBQUQsbUNBQUM7Q0FBQSxBQWhCRCxJQWdCQztTQWhCWSw0QkFBNEIifQ==